import { Component, Vue } from 'vue-property-decorator'
import CAAG1120ViewModel from './CAAG1120ViewModel'
import CAAG1120Service from './CAAG1120Service'
import Header from '@/components/layout/header/HeaderNoRegister.vue'
import CommonConstants from '@/common/CommonConstants'
import SessionStorageService from '@/common/SessionStorageService'
import TransportService from '@/common/TransportService'

@Component({
  name: 'CAAG1120',
  components: { Header }
  })
export default class CAAG1120Controller extends Vue {
  private caag1120ViewModel: CAAG1120ViewModel = {
    redirectRiv: null
  }

  private caag1120Service: CAAG1120Service = new CAAG1120Service()

  /**
   * 画面要素描画後処理
   */
  mounted() {
    document.addEventListener('keydown', this.handleKeyDown)
    document.addEventListener('mousedown', this.handlePopstate)
    this.init()
  }

  /**
   * Vueコンポーネントが破棄される前に作業を実行します。
   */
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown)
    document.removeEventListener('mousedown', this.handlePopstate)
  }

  /**
   * 初期処理
   */
  private async init() {
    const caaa1012ResponseModel = await this.caag1120Service.callAPICAAA1012()

    if (caaa1012ResponseModel.redirectRiv === 4) {
      this.$router.replace({ name: 'caag1010' })
    } else if (caaa1012ResponseModel.redirectRiv === 1) {
      TransportService.callAPITransport(
        CommonConstants.URL_CAAG1060,
        null,
        null
      )
      this.$router.replace({ name: 'caag1060' })
    }
  }

  /**
   * F5キーの操作を防ぐ。
   * @param event F5キーの操作を防ぐ。
   */
  private handleKeyDown(event: KeyboardEvent) {
    if (event.code === 'F5') {
      event.preventDefault()
    }
  }

  /**
   * ブラウザの戻るイベントを阻止します。
   */
  private handlePopstate() {
    window.history.pushState(null, null, window.location.href)
    window.onpopstate = function() {
      window.history.pushState(null, null, window.location.href)
    }
  }
}
